import { PermissionsEnum } from "@/auth/interfaces";
import {
  EstadoPreventaEnum,
  gridSizeMdLg12,
  gridSizeMdLg6,
  ROUTER_PATHS,
  useCheckPermissionsArray,
  useLoaders,
  useTableColumnsInventario,
} from "@/shared";
import {
  CustomAutocomplete,
  CustomTextArea,
  CustomTextFieldNumberComponente,
  SampleTable,
  SingleFormBoxScene,
} from "@/shared/components/ui";
import { CategoriaFCorporativaEnum, MaterialTransferido, TipoDocumentoNameEnum } from "@/shared/interfaces";
import { IPreventaCorporativoForm2 } from "@/shared/interfaces/erp/preventa/preventa_corporativo.interface";
// import SearchIcon from '@mui/icons-material/Search';
import { useNavigate } from "react-router-dom";
import TabDatosGeneralesCorporativo from "../form_preventa_corporativa/TabDatosGeneralesCorporativo";
import TabCaracteristicasEnlaceCorporativo from "../form_preventa_corporativa/TabCaracteristicasEnlaceCorporativo";
import TabServiciosAdicionalesCorporativo from "../form_preventa_corporativa/TabServiciosAdicionalesCorporativo";
import TabPlanesPagos from "../form_preventa_corporativa/TabPlanesPagos";
import { IProspectoCorporativo } from "@/shared/interfaces/erp/prospecto/prospecto_corporativo.interface";
import {
  useFormPreventaCorporativaInstalacion,
  useFormPreventaCorporativaServicio,
} from "@/erp/sale/asesor/preventa/shared/hook/useFormPreventaCorporativa";
import { Button, Grid, Typography } from "@mui/material"; //IconButton
import { TiposTextFieldNumberEnum } from "@/shared/components/ui/CustomTextFieldNumberComponente";
import CondicionVentaSelector from "@/erp/venta-corporativa/prospecto_corporativo/shared/component/CondicionVentaSelector";
import { useSavePreventaCorporativa } from "../hooks";
import SectionLinkDetails from "../form_preventa_corporativa/SectionLinkDetails";
import { MaterialesKey, useMaterialesUtilizadosStore } from "@/store/erp";
import ModalServiciosDigitales from "../ModalServiciosDigitales";
import FileUploadSection from "@/erp/noc/solicitud_venta/components/FileUploadSectionProps/FileUploadSections";

type SavePreventaProps = {
  title: string;
  dataProspecto?: IProspectoCorporativo;
  dataPreventaCorporativa?: IPreventaCorporativoForm2;
  enableEdit?: boolean;
  withPreviousProspecto?: boolean;
  isViewOnly?: boolean;
};

export default function SavePreventaCorporativa({
  title,
  dataProspecto,
  dataPreventaCorporativa,
  enableEdit = false,
  withPreviousProspecto = false,
  isViewOnly = false,
}: SavePreventaProps) {
  const actualEnableEdit = isViewOnly ? false : enableEdit;
  useCheckPermissionsArray([
    PermissionsEnum.api_view_plan,
    PermissionsEnum.api_view_formapago,
  ]);

  const navigate = useNavigate();


  const { columnsItemServiciosDigitales } = useTableColumnsInventario({
    key: MaterialesKey.serviciosAdicionalesDigitales,
  });
  const addSelectedItemProducto = useMaterialesUtilizadosStore().addSelectedItemProducto 
  const serviciosAdicionalesDigitales = useMaterialesUtilizadosStore().serviciosAdicionalesDigitales
  const clearSelectedItems = useMaterialesUtilizadosStore().clearSelectedItems
  // const setAlert = useUiStore((s) => s.setAlert);

  //HANDLER STEPS
  // const steps = [
  //   "Datos Generales",
  //   "Ubicación del Enlace",
  //   "Detalles de Pagos",
  //   "Servicios Adicionales",
  // ];

  // ===========================================================================
  // Stepper
  // ===========================================================================
  // const { activeStep, handleNext, handleBack, disableNextStepBtn } =
  //   useCustomStepper({ steps });

  // ===========================================================================
  // LÓGICA DE PREVENTA CORPORATIVA
  // ===========================================================================
  const {
    form,
    // handleSubmit,
    onSave,
    loadingPostPreventaCorporativo,
    handleBuscarProspectoCorporativo,
    sectorsByZonePaging,
    isLoadingSectors,
    valorRestriccionCel
  } = useSavePreventaCorporativa({
    dataProspecto,
    dataPreventaCorporativa,
    enableEdit,
    withPreviousProspecto,
  });

  // =============================================================================
  // PARA PAGOS DE SERVICIO Y DE INSTALACIÓN
  // =============================================================================
  const {
    formFormasPagosServicio,
    handleFormaPagoServicio,
    dataCooperativaServicio,
    isLoadingCooperativaServicio,
    tipoTarjetaServicio,
    isLoadingEntidadFinancieroServicio,
    dataEntidadFinancieroServicio,
  } = useFormPreventaCorporativaServicio({
    preventa_corporativo_data: form.getValues(),
    editSupervisor: false,
  });
  const {
    formFormasPagosInstalacion,
    handleFormaPagoInstalacion,
    dataCooperativaInstalacion,
    isLoadingCooperativaInstalacion,
    tipoTarjetaInstalacion,
    isLoadingEntidadFinancieroInstalacion,
    dataEntidadFinancieroInstalacion,
  } = useFormPreventaCorporativaInstalacion({
    preventa_corporativo_data: form.getValues()!,
    editSupervisor: false,
  });

  console.log("dataProspectop", dataProspecto)
  console.log("dataPreventaCorporativap", dataPreventaCorporativa)
  
  useLoaders(loadingPostPreventaCorporativo);

  return (
    <>





{/* ${isLoadingCalender ? "" : selectedFlota?.nombre} 
returnUrlPlanificadoresPage
*/}
    <SingleFormBoxScene
      titlePage={title}
      // num_referencia={dataProspecto?.numero_referencia}
      // enableRedirect={true}
      showActionBtns={false}
      showCustomBtns={!isViewOnly}
      customBtns={
        <Grid container spacing={1} justifyContent="end" pt={6}>
          {
            !form.watch().tipo_plan
            &&
            <Grid {...gridSizeMdLg12} item textAlign={"right"}>
              <Typography variant="body2" fontSize={12}>
                Debe escoger un subtipo de contrato para continuar
              </Typography>
            </Grid>
          }
          <Grid item>
            <Button onClick={()=>{
              clearSelectedItems(MaterialesKey.serviciosAdicionalesDigitales)
              navigate(ROUTER_PATHS.ventasCorporativas.preventaCorporativoNav)
            }} variant="text">
              Cancelar
            </Button>
          </Grid>
          {
            !dataPreventaCorporativa?
            <>
              <Grid item>
                <Button onClick={()=>onSave(false)} variant="outlined">
                  Enviar a Prefactibilidad
                </Button>
              </Grid>
              {
                form.watch().tipo_plan && (
                  <Grid item>
                    <Button onClick={()=>onSave(true)} variant="contained">
                      Enviar a Factibilidad
                    </Button>
                  </Grid>
                )
              }
            </>
            :<>
            {
              dataPreventaCorporativa?.preventa_aprobada_factibilidad
              || dataPreventaCorporativa?.estado_preventa===EstadoPreventaEnum.EN_ESPERA?
              null
              :
              form.watch().tipo_plan 
              && (
                <Grid item>
                  <Button onClick={()=>onSave(false)} variant="outlined">
                    Enviar a Prefactibilidad
                  </Button>
                </Grid>
              )
            }
            {
              dataPreventaCorporativa?.preventa_aprobada_factibilidad
              || dataPreventaCorporativa?.estado_preventa===EstadoPreventaEnum.EN_ESPERA?
              null
              :
              form.watch().tipo_plan && (
                <Grid item>
                  <Button onClick={()=>onSave(true)} variant="contained">
                    Enviar a Factibilidad
                  </Button>
                </Grid>
              )
            }
            {
              dataPreventaCorporativa?.preventa_aprobada_factibilidad?
              <Grid item>
                <Button onClick={()=>onSave(true)} variant="contained" color="success">
                  Guardar Cambios
                </Button>
              </Grid>
              :
              null
            }
            </>
          }
          
          
        </Grid>
      }
      // urlRedirect={
      //   ""
      // }
      // textRedirect={"Salir"}
      // iconRedirect={<Close />}
    >
      {/* <Grid container {...gridSizeMdLg12}> */}
        {dataPreventaCorporativa && dataPreventaCorporativa?.tipo_plan ? (
          <Typography>
            Cliente <b>{dataPreventaCorporativa?.tipo_plan}</b>
          </Typography>
        ) : null}
        {form.getValues()?.condicion_venta ? (
          <Typography>
            Condición Venta: <b>{dataProspecto?.condicion_venta || "N/A"}</b>
          </Typography>
        ) : null}
        {dataProspecto?.requiere_cotizacion ||
        dataProspecto?.requiere_inspeccion ? (
          <Typography variant="body1">
            Requiere:
            {"\n"}
            <b>
              {dataProspecto?.requiere_inspeccion ? "INSPECCIÓN" : ""}
              {"\n"}
              {dataProspecto?.requiere_cotizacion ? "COTIZACIÓN" : ""}
            </b>
          </Typography>
        ) : null}
        {withPreviousProspecto ? (<>
          <Grid {...gridSizeMdLg12} paddingTop={2} >
            <Typography variant="h6">DATOS DE PROYECTO PREVIO</Typography>
          </Grid>
          <Grid item container {...gridSizeMdLg12} spacing={2}>
            <Grid
              item
              container
              {...gridSizeMdLg6}
              spacing={2}
              alignItems={"center"}
            >
              <CustomTextFieldNumberComponente
                // disabled={disableIdentification}
                size={gridSizeMdLg12}
                max={
                  form.getValues().tipo_identificacion ==
                  TipoDocumentoNameEnum.CEDULA
                    ? 10
                    : 13
                }
                type={TiposTextFieldNumberEnum.IDENTIFICACION}
                label={"Identificación de Proyecto Previo"}
                error={form.formState.errors.identificacion}
                helperText={form.formState.errors.identificacion?.message}
                control={form.control}
                name="identificacion"
                defaultValue={form.getValues().identificacion || ""}
                onChangeValue={(value) => {
                  if (value?.length == 10 || value?.length == 13)
                    handleBuscarProspectoCorporativo(value);
                }}
              />
              {/* LUPA */}
              {/* <Grid item {...gridSizeConst2}>
                  <IconButton onClick={async(e: any) => {
                    await handleBuscarProspectoCorporativo(form.getValues().identificacion||"")
                    e.preventDefault()
                  }} size="small">
                    <SearchIcon />
                  </IconButton>
                </Grid> */}
            </Grid>
            <Grid item container {...gridSizeMdLg6}>
              <CustomAutocomplete<IProspectoCorporativo>
                size={gridSizeMdLg12}
                label={"Seleccione el Proyecto Previo"}
                name="prospecto_corporativo"
                options={form.getValues().prospecto_corporativo_options || []}
                defaultValue={form.getValues().prospecto_corporativo}
                isLoadingData={false}
                control={form.control}
                error={form.formState.errors.prospecto_corporativo}
                helperText={
                  form.formState.errors.prospecto_corporativo?.message
                }
                onChangeRawValue={(value) => {
                  console.log({ value });
                  form.reset({
                    ...form.getValues(),
                    celular_1: value?.celular,
                    celular: value?.celular,
                    observacion_vendedor:
                      value?.observaciones?.observacion_vendedor,
                    prospecto_corporativo_data: value,
                    email: value?.email,
                    persona_contacto: value?.persona_contacto,
                    direccion: value?.direccion,
                  });
                }}
                valueKey="razon_social"
                actualValueKey="codigo"
              />
            </Grid>

            <CondicionVentaSelector form={form} />
          </Grid>
          </>
        ) : null}
      {/* </Grid> */}
      
      <Grid container {...gridSizeMdLg12} marginY={4}>
        <Typography variant="h6" fontWeight={700}>DATOS GENERALES</Typography>
      </Grid>
      <TabDatosGeneralesCorporativo
        form={form}
        enableEdit={actualEnableEdit}
        valorRestriccionCel={valorRestriccionCel}
      />
      <TabCaracteristicasEnlaceCorporativo
        form={form}
        sectorsByZonePaging={sectorsByZonePaging}
        isLoadingSectors={isLoadingSectors}
      />

      <Grid container {...gridSizeMdLg12} marginY={2}>
        <Typography variant="h6" fontWeight={700}>DATOS DEL SERVICIO</Typography>
      </Grid>
      <SectionLinkDetails
        form={form}
        enableEdit={actualEnableEdit}
      />

      
      <Grid container {...gridSizeMdLg12} marginY={2}>
        <Typography variant="h6" fontWeight={700}>SERVICIOS ADICIONALES</Typography>
      </Grid>
      

      <Grid {...gridSizeMdLg12} container justifyContent={"end"}>

          <ModalServiciosDigitales
            onChange={(e) => {
              const aux: MaterialTransferido = {
                id: e.id_servicio_digital!,
                cantidad: 1,
                codigo: e.codigo,
                series: [],
                contiene_serie: false,
                nombre: e.nombre!,
                categoria_fcorporativa: CategoriaFCorporativaEnum.SERVICIOS_DIGITALES,
                precioUnitario: parseFloat(e?.precios?.[0]?.precio || "0"),
                producto_data: {
                  categoria_producto: e.categoria_producto!,
                  codigo: e.codigo,
                  descripcion: e.nombre!,
                  stock_actual: 1000,
                  subcategoria_producto: "N/A",
                  precios: e.precios || [],
                },
              };
              console.log({aux})
              addSelectedItemProducto(aux, MaterialesKey.serviciosAdicionalesDigitales);
            }}
          />
      </Grid>
      <Grid item xs={12}>
        <SampleTable<any>
          // rowNumber={true}
          columns={columnsItemServiciosDigitales}
          data={
            serviciosAdicionalesDigitales//.filter(x=>x.categoria_fcorporativa==CategoriaFCorporativaEnum.SERVICIOS_DIGITALES)
            ||[]
          }
        />
      </Grid>


      
      <Grid container {...gridSizeMdLg12} marginY={2}>
        <Typography variant="h6" fontWeight={700}>OTROS SERVICIOS</Typography>
      </Grid>
      <TabServiciosAdicionalesCorporativo
        form={form}
        enableEdit={actualEnableEdit}
      />



      <Grid container {...gridSizeMdLg12} marginY={2}>
        <Typography variant="h6" fontWeight={700}>MÉTODOS DE PAGO</Typography>
      </Grid>
      <TabPlanesPagos
        form={form}
        formFormasPagosServicio={formFormasPagosServicio}
        handleFormaPagoServicio={handleFormaPagoServicio}
        dataCooperativaServicio={dataCooperativaServicio}
        isLoadingCooperativaServicio={isLoadingCooperativaServicio}
        tipoTarjetaServicio={tipoTarjetaServicio}
        isLoadingEntidadFinancieroServicio={
          isLoadingEntidadFinancieroServicio
        }
        dataEntidadFinancieroServicio={dataEntidadFinancieroServicio}
        formFormasPagosInstalacion={formFormasPagosInstalacion}
        handleFormaPagoInstalacion={handleFormaPagoInstalacion}
        tipoTarjetaInstalacion={tipoTarjetaInstalacion}
        dataCooperativaInstalacion={dataCooperativaInstalacion}
        isLoadingCooperativaInstalacion={isLoadingCooperativaInstalacion}
        dataEntidadFinancieroInstalacion={dataEntidadFinancieroInstalacion}
        isLoadingEntidadFinancieroInstalacion={
          isLoadingEntidadFinancieroInstalacion
        }
        enableEdit={actualEnableEdit}
      />
      
      
      <Grid container {...gridSizeMdLg12} marginY={4}>
        <CustomTextArea
          label="Observaciones Prefactibilidad"
          name="observacion_prefactibilidad"
          autoGrow
          maxRows={14}
          control={form.control}
          defaultValue={form.getValues()?.observacion_prefactibilidad || form.getValues()?.observaciones?.observacion_prefactibilidad || "N/A"}
          error={form.formState.errors?.observacion_prefactibilidad}
          helperText={form.formState.errors?.observacion_prefactibilidad?.message}
          required={false}
          size={gridSizeMdLg12}
          disabled={true}
        />
      </Grid>

      <Grid container {...gridSizeMdLg12}>
        {
          form.getValues()?.preventa_aprobada_factibilidad?
          <CustomTextArea
            label="Observaciones Adicionales"
            name="observacion_preventa"
            autoGrow
            maxRows={14}
            control={form.control}
            defaultValue={form.getValues()?.observacion_preventa || form.getValues()?.observaciones?.observacion_preventa || ""}
            error={form.formState.errors?.observacion_preventa}
            helperText={form.formState.errors?.observacion_preventa?.message}
            required={false}
            disabled={!actualEnableEdit}
            size={gridSizeMdLg12}
          />
          :null
        }
      </Grid>

      {dataPreventaCorporativa && (
        <Grid container {...gridSizeMdLg12} marginY={4}>
          <Grid item {...gridSizeMdLg12} sx={{ borderBottom: '2px solid #1976d2', pb: 1, mb: 3 }}>
            <Typography variant="h6" fontWeight={700}>
              Información Adicional
            </Typography>
          </Grid>

          <Grid item {...gridSizeMdLg12} sx={{ mb: 3 }}>
            <Typography variant="subtitle1" fontWeight={600} sx={{ mb: 1 }}>
              Área Responsable
            </Typography>
            <Typography>
              {dataPreventaCorporativa.area_responsable_inspeccion || "No definida"}
            </Typography>
          </Grid>

          <Grid item {...gridSizeMdLg6} sx={{ pr: { md: 2 } }}>
            <FileUploadSection
              titulo="Documento de Inspección"
              archivoSeleccionado={null}
              setArchivoSeleccionado={() => {}}
              urlArchivoGuardado={dataPreventaCorporativa.url_archivo_inspeccion_adicional}
              disabledField={true}
              inputId="preventa-doc-inspeccion"
            />
          </Grid>

          <Grid item {...gridSizeMdLg6} sx={{ pl: { md: 2 } }}>
            <FileUploadSection
              titulo="Documento Propuesta Técnica"
              archivoSeleccionado={null}
              setArchivoSeleccionado={() => {}}
              urlArchivoGuardado={dataPreventaCorporativa.url_archivo_propuesta_tecnica}
              disabledField={true}
              inputId="preventa-doc-propuesta-tecnica"
            />
          </Grid>
        </Grid>
      )}

    </SingleFormBoxScene>



    </>
  );
}






// <StepperBoxScene
// py={1}
// titlePage={title}
// num_referencia={dataProspecto?.numero_referencia}
// steps={steps}
// activeStep={activeStep}
// handleNext={handleNext}
// handleBack={handleBack}
// disableNextStepBtn={disableNextStepBtn}
// onCancel={() =>
//   navigate(ROUTER_PATHS.ventasCorporativas.preventaCorporativoNav)
// }
// additionalNoteText={
//   <>
//     {dataPreventaCorporativa && dataPreventaCorporativa?.tipo_plan ? (
//       <Typography>
//         Cliente <b>{dataPreventaCorporativa?.tipo_plan}</b>
//       </Typography>
//     ) : null}
//     {form.getValues()?.condicion_venta ? (
//       <Typography>
//         Condición Venta: <b>{dataProspecto?.condicion_venta || "N/A"}</b>
//       </Typography>
//     ) : null}
//     {dataProspecto?.requiere_cotizacion ||
//     dataProspecto?.requiere_inspeccion ? (
//       <Typography variant="body1">
//         Requiere:
//         {"\n"}
//         <b>
//           {dataProspecto?.requiere_inspeccion ? "INSPECCIÓN" : ""}
//           {"\n"}
//           {dataProspecto?.requiere_cotizacion ? "COTIZACIÓN" : ""}
//         </b>
//       </Typography>
//     ) : null}
//     {withPreviousProspecto ? (
//       <Grid item container {...gridSizeMdLg12} spacing={2}>
//         <Grid item {...gridSizeMdLg12}>
//           <Typography variant="h6">DATOS DE PROSPECTO PREVIO</Typography>
//         </Grid>
//         <Grid
//           item
//           container
//           {...gridSizeMdLg6}
//           spacing={2}
//           alignItems={"center"}
//         >
//           <CustomTextFieldNumberComponente
//             // disabled={disableIdentification}
//             size={gridSizeMdLg12}
//             max={
//               form.getValues().tipo_identificacion ==
//               TipoDocumentoNameEnum.CEDULA
//                 ? 10
//                 : 13
//             }
//             type={TiposTextFieldNumberEnum.IDENTIFICACION}
//             label={"Identificación de Prospecto Previo"}
//             error={form.formState.errors.identificacion}
//             helperText={form.formState.errors.identificacion?.message}
//             control={form.control}
//             name="identificacion"
//             defaultValue={form.getValues().identificacion || ""}
//             onChangeValue={(value) => {
//               if (value?.length == 10 || value?.length == 13)
//                 handleBuscarProspectoCorporativo(value);
//             }}
//           />
//           {/* LUPA */}
//           {/* <Grid item {...gridSizeConst2}>
//               <IconButton onClick={async(e: any) => {
//                 await handleBuscarProspectoCorporativo(form.getValues().identificacion||"")
//                 e.preventDefault()
//               }} size="small">
//                 <SearchIcon />
//               </IconButton>
//             </Grid> */}
//         </Grid>
//         <Grid item container {...gridSizeMdLg6}>
//           <CustomAutocomplete<IProspectoCorporativo>
//             size={gridSizeMdLg12}
//             label={"Prospecto Previo"}
//             name="prospecto_corporativo"
//             options={form.getValues().prospecto_corporativo_options || []}
//             defaultValue={form.getValues().prospecto_corporativo}
//             isLoadingData={false}
//             control={form.control}
//             error={form.formState.errors.prospecto_corporativo}
//             helperText={
//               form.formState.errors.prospecto_corporativo?.message
//             }
//             onChangeRawValue={(value) => {
//               console.log({ value });
//               form.reset({
//                 ...form.getValues(),
//                 celular_1: value?.celular,
//                 celular: value?.celular,
//                 observacion_vendedor:
//                   value?.observaciones?.observacion_vendedor,
//                 prospecto_corporativo_data: value,
//                 email: value?.email,
//                 persona_contacto: value?.persona_contacto,
//                 direccion: value?.direccion,
//               });
//             }}
//             valueKey="razon_social"
//             actualValueKey="codigo"
//           />
//         </Grid>

//         <CondicionVentaSelector form={form} />
//       </Grid>
//     ) : null}
//   </>
// }
// onSave={handleSubmit(onSave, (error) => {
//   handleAxiosError(error);
//   return setAlert(
//     true,
//     "Revise que todos los campos sean correctos",
//     AlertSeverityEnum.error
//   );
// })}
// size={gridSizeMdLg12}
// >
// {/* "Datos Generales", */}
// {activeStep === 0 && <TabDatosGeneralesCorporativo 
// form={form} 
// enableEdit={enableEdit}
// />}
// {/* "Características del Enlace", */}
// {activeStep === 1 && (
//   <TabCaracteristicasEnlaceCorporativo
//     form={form}
//     sectorsByZonePaging={sectorsByZonePaging}
//     isLoadingSectors={isLoadingSectors}
//   />
// )}
// {/* "Detalles de Plan", */}
// {activeStep === 2 && (
//   <TabPlanesPagos
//     form={form}
//     formFormasPagosServicio={formFormasPagosServicio}
//     handleFormaPagoServicio={handleFormaPagoServicio}
//     dataCooperativaServicio={dataCooperativaServicio}
//     isLoadingCooperativaServicio={isLoadingCooperativaServicio}
//     tipoTarjetaServicio={tipoTarjetaServicio}
//     isLoadingEntidadFinancieroServicio={
//       isLoadingEntidadFinancieroServicio
//     }
//     dataEntidadFinancieroServicio={dataEntidadFinancieroServicio}
//     formFormasPagosInstalacion={formFormasPagosInstalacion}
//     handleFormaPagoInstalacion={handleFormaPagoInstalacion}
//     tipoTarjetaInstalacion={tipoTarjetaInstalacion}
//     dataCooperativaInstalacion={dataCooperativaInstalacion}
//     isLoadingCooperativaInstalacion={isLoadingCooperativaInstalacion}
//     dataEntidadFinancieroInstalacion={dataEntidadFinancieroInstalacion}
//     isLoadingEntidadFinancieroInstalacion={
//       isLoadingEntidadFinancieroInstalacion
//     }
//     enableEdit={enableEdit}
//   />
// )}
// {/* "Servicios Adicionales" */}
// {activeStep === 3 && (
//   <TabServiciosAdicionalesCorporativo
//     form={form}
//     enableEdit={enableEdit}
//   />
// )}
// </StepperBoxScene>